import $ from 'jquery';
import 'jquery-validation';
import 'select2';

export default function select() {
  function formatProductsList(product) {
    const filtered = replaceSymbols(product.text);
    let final = filtered;

    if (filtered.indexOf('(') !== -1) {
      const drugName = filtered.substring(filtered.indexOf('('), filtered.length);
      final = filtered.replace(drugName, '<span>' + drugName + '</span>');
    }

    return $('<div class="option">' + final + '</div>');
  }

  function formatProductsSelected(product) {
    return $('<span>' + getProductShortName(product.text) + '</span><span class="comma">,&nbsp;</span>');
  }

  function getProductShortName(productStr) {
    const filtered = replaceSymbols(productStr);

    if (filtered.indexOf(' (') !== -1) {
      return filtered.substring(0, filtered.indexOf(' ('));
    }
    return filtered;
  }

  function replaceSymbols(productStr) {
    const replacedRegs = productStr.replace('®', '&reg;');
    const replacedTMs = replacedRegs.replace('™', '&trade;');
    return replacedTMs;
  }

  function generateQuestionBox(productStr, index) {
    return [
      '<div class="product-questions__item">',
      '<p><strong>' + getProductShortName(productStr) + '</strong></p>',
      '<label class="form__label" for="Question' + index + '">Enter your question(s)<span class="txt-prim">*</span></label>',
      '<textarea class="field" maxlength="1000" name="Question' + index + '" id="Question' + index + '" placeholder="1000 characters max"></textarea>',
      '</div>'
    ].join('');
  }

  $('select:not([multiple]):not([name=Product]):not([name="inducer"])').select2({
    placeholder: 'Please select...',
    width: '100%',
  }).on('change', function() {
    $(this).valid();
  });

  $('select[name=Product][multiple]').select2({
    placeholder: 'Please select...',
    width: '100%',
    maximumSelectionLength: 4,
    templateResult: formatProductsList,
    templateSelection: formatProductsSelected
  }).on('change', function() {
    // gets select box selections and creates a comma separated string and sets it to the value of the hidden input
    $(this).parents('form').find('[name=product-sum]').val(($(this).select2('data').map(el => el.element.value).join(', ')));
    $(this).parents('form').find('.js-product-questions').html($(this).select2('data').map((el, index) => {
      return generateQuestionBox(el.text, index + 1);
    }).join(''));
    $(this).valid();
  });

  $('select[name=Product]:not([multiple])').select2({
    placeholder: 'Please select...',
    width: '100%',
    templateResult: formatProductsList
  }).on('change', function(e) {
    if (e.target.value === '') return;
    $(this).valid();
  });

  if ( $('.page-len4prep').length ) {
    const $inducerSelect = $('select[name="inducer"]');

    $inducerSelect.select2({
      placeholder: $inducerSelect.data('placeholder') || 'Please select...',
      width: '100%',
      minimumResultsForSearch: -1,
      escapeMarkup: markup => markup,
      templateResult: data => data.id ? $(data.element).html() : data.text,
      templateSelection: data => data.id ? $(data.element).html() : data.text,
    });
  }

  $(document).on('select2:open', () => {
    setTimeout(() => {
      if ( $('.select2-container--open .select2-search__field').length ) {
        document.querySelector('.select2-container--open .select2-search__field').focus();
      }
    }, 100);
  });
}


// WEBPACK FOOTER //
// ./src/assets/js/project/select.js